module.exports = __webpack_public_path__ + "static/img/张靖皋3.2d3ec881.png";